import { type ReactNode, useId } from 'react';

import { Separator } from '@nesso/ui/primitives/separator';

export function SettingsSection({
    title,
    badge,
    className,
    children,
}: {
    title: string;
    badge?: ReactNode;
    className?: string;
    children: ReactNode;
}) {
    const headingId = useId();

    const heading = (
        <h2 id={headingId} className="text-xl font-bold">
            {title}
        </h2>
    );

    return (
        <section aria-labelledby={headingId} className={className}>
            {badge ? (
                <div className="flex items-center gap-2">
                    {heading}
                    {badge}
                </div>
            ) : (
                heading
            )}
            {/* Figma draws its divider at zero height, in the pixel row above its layout
                position, so the line's own pixel comes out of the margin above it, not below. */}
            <Separator className="mt-[15px] mb-4" />
            {children}
        </section>
    );
}
